import styled from "styled-components";
import { Anchor, Type } from "discover.medical.react-component-library";

export const Header = styled(Type)`
  font-size: ${({ theme }) => theme.font.size.xxl};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: ${({ theme }) => theme.font.size.xxl};
  }
`;

export const Description = styled(Type)`
  font-size: ${({ theme }) => theme.font.size.sm};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: ${({ theme }) => theme.font.size.md};
  }
`;

export const AppStoreImage = styled.img`
  margin-right: ${({ theme }) => theme.space.sm};
  width: ${({ $appStoreImageWidth }) => $appStoreImageWidth || "155px"};
  height: ${({ $appStoreImageHeight }) => $appStoreImageHeight || "60px"};
`;

export const HowToInstallLink = styled(Anchor)`
  display: inline;

  > svg {
    vertical-align: middle;
  }
`;
